import {
  TBulkCountAppBackgroundDB,
  TBulkCountAppEventWithStatus,
  TBulkCountAppUserActualsDB,
  TBulkCountPendingTransactions,
  TBulkCountPendingTransactionWithBctxList,
} from '@monorepo/types';
import { EventUtil } from '../event-util';

export const BulkCountAppEventUtil = {
  hasAnyPendingEvents(userDB: TBulkCountAppUserActualsDB, bgDB: TBulkCountAppBackgroundDB) {
    if (
      bgDB.persistanceCache.pastDaysList.length > 0 ||
      userDB.dailyCache.events.list.length !== bgDB.dailyCache.events.list.length
    )
      return true;
    else return this.hasAnyYetToBeSyncedEventsInBgDB(bgDB.dailyCache.events.list);
  },

  hasAnyYetToBeSyncedEventsInBgDB(events: TBulkCountAppBackgroundDB['dailyCache']['events']['list']) {
    return this.getLastSyncedIndexInBgDB(events) === events.length - 1 ? false : true;
  },
  getLastSyncedIndexInBgDB(events: TBulkCountAppBackgroundDB['dailyCache']['events']['list']) {
    for (let index = 0; index < events.length; index++) {
      if (events[index].eventStatus === 'YET_TO_BE_SYNCED') return index - 1;
    }
    return events.length - 1;
  },
  getNonDelayedEvents(
    delayedEventsSLAInDays: number,
    pastDaysEvents: TBulkCountAppEventWithStatus[],
    cacheResetTime: number,
  ) {
    const delayedBorder = EventUtil.getDelayedEventsBorderTime(delayedEventsSLAInDays, cacheResetTime);
    return pastDaysEvents.filter((item) => item.event.metaData.eventTime >= delayedBorder);
  },
  getNonDelayedTransactions(
    delayedEventsSLAInDays: number,
    transactions: TBulkCountPendingTransactions,
    cacheResetTime: number,
  ) {
    const delayedBorder = EventUtil.getDelayedEventsBorderTime(delayedEventsSLAInDays, cacheResetTime);
    return transactions.filter((item) => item.timeStamp >= delayedBorder);
  },
  getLastSyncedIndex(events: TBulkCountAppEventWithStatus[]) {
    for (let index = 0; index < events.length; index++) {
      if (events[index].backgroundMetadata.eventStatus === 'YET_TO_BE_SYNCED') return index - 1;
    }
    return events.length - 1;
  },
};
